import { render } from "./WhatsAppModalSidebarRightChatMessageContainerMessagesDocument.vue?vue&type=template&id=e8461e32"
import script from "./WhatsAppModalSidebarRightChatMessageContainerMessagesDocument.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightChatMessageContainerMessagesDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__